import React, { useContext } from "react";
import { NativeAPI } from "src/utils/deviceUtils";
import TranslationsContext from "src/contexts/TranslationsContext";
import styles from "./KuUpsell.module.scss";
import { newMetricsWithContext } from "src/utils/metricsUtils";
import { getProgramSticker } from "src/utils/programLogoUtils";
import DeviceContext from "src/contexts/DeviceContext";
import { getKuUpsell } from "src/utils/aapiResponseUtils";
import { getCurrentBaseUrl } from "src/utils/urlUtils";

type PropTypes = {
    item: QuickViewAsinMetadata;
    hasFullBook: boolean;
};

const KuUpsell: React.FC<PropTypes> = ({ item, hasFullBook }: PropTypes) => {
    const translations = useContext(TranslationsContext);
    const deviceContext = useContext(DeviceContext);
    const metrics = newMetricsWithContext("KuUpsell");

    if (!item.hasKuUpsell || hasFullBook || item.canBorrow) {
        return null;
    }

    const kuUpsell = getKuUpsell(item.allBuyingOptions);
    if (!kuUpsell) {
        return null;
    }

    const openKu = () => {
        metrics.recordBehavioralMetric(`KuTrial.click`, 1);
        // NOTE: openWebPageExternal expects a fully qualified URL
        const kuUpsellUrl = `${getCurrentBaseUrl()}/kindle-dbs/hz/subscribe/ku?passThroughAsin=${item.asin}&nodl=0&ref_=rekindleQVKU`;
        if (!NativeAPI.openWebPageExternal(kuUpsellUrl)) {
            NativeAPI.openWebPage(kuUpsellUrl);
        }
    };

    const kuLogo = getProgramSticker(deviceContext.theme, item.kindleProgramLowCost);
    const altText = kuLogo?.altText || translations.getText(kuLogo?.altKey ?? "");

    return (
        <div role="button" tabIndex={0} onClick={openKu} className={`${styles.kuUpsell} ${styles[deviceContext.theme]}`} >
            <div className={styles.upsellText}>
                <div className={styles.kuLogo}>
                    <img className={styles.kuLogo} src={kuLogo?.src} alt={altText} />
                </div>
                {kuUpsell.kindleProgram?.entity?.longMessage ?? kuUpsell.kindleProgram?.entity?.shortMessage}
            </div>
            <div className={styles.chevronIconContainer}>
                <div className={styles.chevronIcon} />
            </div>
        </div>
    );
};

export default KuUpsell;
